/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AuthMode = {
    Oauth: 'OAUTH',
    Paragon: 'PARAGON'
} as const;
export type AuthMode = typeof AuthMode[keyof typeof AuthMode];


export function AuthModeFromJSON(json: any): AuthMode {
    return AuthModeFromJSONTyped(json, false);
}

export function AuthModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthMode {
    return json as AuthMode;
}

export function AuthModeToJSON(value?: AuthMode | null): any {
    return value as any;
}

